var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLocking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_locking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_locking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#C60000",
    fill: "#FFFFFF",
    cx: 9,
    cy: 9,
    r: 8.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(6.000000, 5.000000)",
    fill: "#C60000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9798,0 C1.8858,0 0.9998,0.886 0.9998,1.98 L1,3 L2,3 L1.9998,1.99 C1.9998,1.443 2.4428,1 2.9898,1 L3.0098,1 C3.5568,1 3.9998,1.443 3.9998,1.99 L4,6 L5,6 L4.9998,1.98 C4.9998,0.886 4.1138,0 3.0198,0 L2.9798,0 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,5 L2,5 L1,5 C0.448,5 0,5.448 0,6 L0,8.00104344 C0,8.55275191 0.45097518,9 0.990777969,9 L5.00922203,9 C5.55641359,9 6,8.55733967 6,8.00104344 L6,6 C6,5.448 5.552,5 5,5 L4,5 Z",
    id: "Fill-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocking);
export default __webpack_public_path__ + "static/media/icon_locking.49f2166ffa16e04b7c82b706e1e84012.svg";
export { ForwardRef as ReactComponent };